<div class="close">
  <button (click)="close()">
    <img
      alt="close"
      width="20"
      height="20"
      src="../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">温馨提示</div>
<div class="content">
  <div>
    如果您的电视或设备提示“您的设备不属于此账户的Netflix同户设备”，请点击“暂时观看”或“我在旅行”
  </div>
  <div style="margin: 40px 0">点击确认，即可在这个界面获取正确的登入验证码</div>
  <div class="tip">
    <mat-icon style="color: rgb(244, 105, 105)">error</mat-icon>
    如果您没有遇到登录验证，请忽略此功能
  </div>
  <div class="button">
    <button class="button1" (click)="close()">取消</button>
    <button class="button2" (click)="onOk()">确认</button>
  </div>
</div>
